import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { VivaQuestionPopupComponent } from './viva-question-popup.component';

@NgModule({
  declarations: [
    VivaQuestionPopupComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective
  ],
  exports: [
    VivaQuestionPopupComponent
  ]
})
export class  VivaQuestionPopupModule { }
